import { QueryFunctionContext } from '@tanstack/react-query';
import { adminApi, api } from './axios';

export function fetcher({ queryKey }: QueryFunctionContext) {
  return api.get(queryKey[0] as string).then(({ data }) => data);
}

export function adminFetcher({ queryKey }: QueryFunctionContext) {
  return adminApi.get(queryKey[0] as string).then(({ data }) => data);
}
